'use client';

import React, { FC } from 'react';

interface ContentContainerProps {
    id: string;
    children: React.ReactNode;
}

const ContentContainer: FC<ContentContainerProps> = ({ children, id }) => {
    return (
        <div id={id} className="min-h-[300px] bg-white">
            {children}
        </div>
    );
};

export default ContentContainer;
